import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { BUSINESS, telLink, whatsappLink } from "@/data/business";
import { btnPrimary, btnOutlineWhite, container } from "@/lib/ui";

export function CtaBand({
  title = "Ready for a cleaner, fresher home?",
  subtitle = "Request your free, no-obligation quote today. We usually reply the same business day.",
}) {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid="cta-band">
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-brandgreen/10 blur-3xl" />
      <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-brandgreen/10 blur-3xl" />
      <div className={`${container} relative py-16 lg:py-20`}>
        <div className="max-w-3xl">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white tracking-tight">
            {title}
          </h2>
          <p className="mt-4 text-base lg:text-lg text-white/80 leading-relaxed">{subtitle}</p>
          <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-4">
            <Link to="/quote" className={btnPrimary} data-testid="cta-band-quote">
              Get a Free Quote <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={telLink} className={btnOutlineWhite} data-testid="cta-band-call">
              <Phone className="w-4 h-4" /> Call {BUSINESS.phoneDisplay}
            </a>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className={btnOutlineWhite}
              data-testid="cta-band-whatsapp"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
